import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Columns } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import React from 'react';
import { NoDataVisual } from '../../../pages/SavingsUtilization';

type CategoryTableProps = {
  columns: Columns[];
  rowsData: any[];
  isCategory: boolean;
  borderRadius?: string;
  padding?: string;
};

interface CategoryTableSectionProps {
  item: any[];
  isCategory: boolean;
  columnsLength: number;
  classes: Record<string, string>;
  itemIndex: number;
}

const CategoryTableSection: React.FC<CategoryTableSectionProps> = ({
  item,
  isCategory,
  columnsLength,
  classes,
  itemIndex,
}) => {
  const renderCategoryRow = () => (
    <TableRow key={`category-${itemIndex}`}>
      <TableCell className={classes.categoryRow} colSpan={columnsLength}>
        {item[0]}
      </TableCell>
    </TableRow>
  );

  const renderDataRows = () => {
    return isCategory ? (
      item.slice(1).map((row: any, rowIndex: number) => (
        <TableRow
          style={{
            backgroundColor: row[row.length - 1],
          }}
          key={`row-${itemIndex}-${rowIndex}`}
        >
          {row.slice(0, -1).map((field: any, colIndex: number) => (
            <TableCell
              key={`cell-${itemIndex}-${rowIndex}-${colIndex}`}
              className={classes.cell}
            >
              {field}
            </TableCell>
          ))}
        </TableRow>
      ))
    ) : (
      <TableRow
        style={{ backgroundColor: item[item.length - 1] }}
        key={`row-${itemIndex}`}
      >
        {item.slice(1, -1).map((row: any, rowIndex: number) => (
          <TableCell
            key={`cell-${itemIndex}-${rowIndex}`}
            className={classes.cell}
          >
            {row}
          </TableCell>
        ))}
      </TableRow>
    );
  };

  return (
    <>
      {isCategory && renderCategoryRow()}
      {renderDataRows()}
    </>
  );
};

const CategoryTable: React.FC<CategoryTableProps> = ({
  columns,
  rowsData,
  isCategory,
  borderRadius,
  padding,
}) => {
  const { classes } = makeStyles()({
    table: {
      border: '1px solid ' + patientAccessTheme.palette.grey[300],
      borderRadius: borderRadius ? borderRadius : '0.5rem',
      overflow: 'hidden',
      marginBottom: '1rem',
    },
    headerRow: {
      backgroundColor: isCategory
        ? patientAccessTheme.palette.grey[100]
        : patientAccessTheme.palette.grey[700],
      '& th:last-child': {
        borderRight: 'none',
      },
    },
    categoryRow: {
      backgroundColor: patientAccessTheme.palette.grey[700],
      color: patientAccessTheme.palette.status.white,
      padding: '8px 0px 8px 20px',
    },
    cell: {
      padding: padding ? padding : '20px 20px 16px 20px',
      borderRight: '1px solid ' + patientAccessTheme.palette.grey[300],
      borderBottom: '1px solid ' + patientAccessTheme.palette.grey[300],
      verticalAlign: 'top',
    },
  })();

  const getColumnsRow = () => {
    return columns.map((item) => (
      <TableCell
        className={classes.cell}
        style={{
          width: item.width,
          ...item.cellStyles,
          color: isCategory
            ? patientAccessTheme.palette.text.highemphasis
            : patientAccessTheme.palette.status.white,
        }}
      >
        {item.name}
      </TableCell>
    ));
  };

  return (
    <>
      {rowsData.length > 0 ? (
        <Grid className={classes.table}>
          <Table>
            <TableHead>
              <TableRow className={classes.headerRow}>
                {getColumnsRow()}
              </TableRow>
            </TableHead>
            <TableBody>
              {rowsData.map((item, index) => (
                <CategoryTableSection
                  key={`section-${index}`}
                  item={item}
                  isCategory={isCategory}
                  columnsLength={columns.length}
                  classes={classes}
                  itemIndex={index}
                />
              ))}
            </TableBody>
          </Table>
        </Grid>
      ) : (
        <NoDataVisual text="We couldn't find any data that matches the selected parameters and confidence scores" />
      )}
    </>
  );
};

export default CategoryTable;
